import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  if (!items.length) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      item: {
        '@id': item.path ? `https://chigua-spa.com${item.path}` : undefined,
        name: item.label,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="px-4 md:px-6 py-3 bg-background-50 border-b border-background-200/70">
        <ol className="flex items-center gap-2 text-xs text-foreground-500 max-w-7xl mx-auto whitespace-nowrap overflow-x-auto">
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-2">
              {idx > 0 && <span className="text-foreground-300">/</span>}
              {item.path && idx < items.length - 1 ? (
                <Link to={item.path} className="hover:text-primary-600 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className={idx === items.length - 1 ? 'text-foreground-800 font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}